module.exports = __webpack_public_path__ + "static/img/info-block-szechenyi-2020-top-right-160px.c0cdc4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info-block-szechenyi-2020-top-right-160px.png
// module id = 74d9
// module chunks = 1